<template>
  <div class="mobileDone clearfix">
    <div class="header">提交订单</div>
    <div class="success clearfix" v-if="status=='success'">
      <p>
        <van-icon name="checked" size="0.6rem" color="#219df3"/>
      </p>
      <p>订单支付成功</p>
    </div>
    <div class="success clearfix fail" v-else>
      <p>
        <van-icon name="clear" size="0.6rem" color="#f44"/>
      </p>
      <p>订单支付失败</p>
    </div>
    <div class="donefooter">
      <div class="user">
        <a href="https://m.suhuishou.com/user">用户中心</a>
      </div>
      <div class="order">
        <a href="https://m.suhuishou.com/order">订单信息</a>
      </div>
    </div>
    <div class="hxbox">
      <button @click="onclick">一键领取</button>
    </div>
    <van-popup v-model="show">
      <div class="hxsuccess">
        <p>
          <a href="https://hx.suhuishou.com/mobile">去查看</a>
          <a href="https://hx.suhuishou.com/mobile">立即使用</a>
        </p>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  name: "Done",
  data() {
    return {
      status: "success",
      show: false
    };
  },
  components: {},
  computed: {},
  mounted: function() {
    if (this.$route.query.status) {
      this.status = this.$route.query.status;
    }
  },
  methods: {
    onclick() {
      this.show = !this.show;
    }
  },
  created() {}
};
</script>

<style scoped>
.van-popup {
  background: none;
}
.mobileDone {
  width: 100%;
  font-size: 0.14rem;
  overflow: hidden;
  padding: 0rem 0 0rem 0;
}
.mobileDone .header {
  height: 0.6rem;
  line-height: 0.6rem;
  text-align: center;
  position: relative;
  background: #fff;
}
.mobileDone .header .header-left {
  position: absolute;
  left: 0.1rem;
  top: 0.23rem;
}
.success {
  background-color: #fff;
  text-align: center;
  padding: 0.2rem 0 0.2rem;
}
.success svg {
  width: 0.6rem;
  height: 0.6rem;
  margin-bottom: 0.05rem;
}
.success p {
  line-height: 0.25rem;
  font-size: 0.2rem;
  color: #000;
  margin: 0.1rem 0;
}
.success p:nth-child(3) {
  font-size: 0.15rem;
  color: #999;
  margin-top: 0.05rem;
}
.success .icon-check {
  font-size: 0.6rem;
  color: #219df3;
}
.done .desc {
  border-top: #efefef solid 1px;
  background-color: #fff;
  line-height: 0.2rem;
  padding: 0.1rem;
  text-align: center;
}
.done .desc p {
  color: #999;
}
.done .desc .iconfont {
  font-size: 0.15rem;
}
.done .desc span {
  margin-left: 0.1rem;
  font-size: 0.14rem;
}
.done .donehelp {
  border-top: solid #efefef 5px;
  padding: 0.2rem 0.1rem;
}
.done .donehelp p {
  color: #888;
  font-size: 0.14rem;
  margin-bottom: 0.1rem;
}
.donefooter {
  display: flex;
  width: 100%;
  padding-top: 0.1rem;
}
.donefooter .user {
  flex: 1;
  text-align: center;
}
.donefooter .order {
  flex: 1;
  text-align: center;
}
.donefooter a {
  color: #ccc;
  display: inline-block;
  height: 0.35rem;
  width: 90%;
  text-align: center;
  line-height: 0.35rem;
  border-radius: 0.01rem;
  background-color: #fff;
}
.donefooter .order a {
  background: #219df3;
  color: #fff;
}
.donefooter .user a {
  color: #666;
  border: solid #e2e2e2 1px;
}
.hxbox {
  width: 3.3rem;
  height: 2.22rem;
  background: url(https://suhuishoutp.oss-cn-shenzhen.aliyuncs.com/assets/image/hxquan.png)
    no-repeat;
  background-size: 100%;
  margin: 0 auto;
  margin-top: 0.4rem;
  position: relative;
  padding-top: 1px;
}
.hxbox button {
  display: block;
  width: 1.4rem;
  height: 0.32rem;
  margin: 1.76rem auto 0;
  background: #fbda30;
  color: #000;
  border: 0;
  border-radius: 50px;
  color: #552ada;
}
.hxsuccess {
  width: 2.67rem;
  height: 3.75rem;
  background: url(https://suhuishoutp.oss-cn-shenzhen.aliyuncs.com/assets/image/hxsuccess.png)
    no-repeat;
  background-size: 100%;
  margin: 0 auto;
  position: relative;
  padding-top: 1px;
  position: relative;
}
.hxsuccess p {
  position: absolute;
  bottom: 0.2rem;
  text-align: center;
  width: 100%;
}
.hxsuccess p a {
  color: #fff;
  display: inline-block;
  padding: 0.07rem 0.2rem;
  background: #56ccff;
  border-radius: 50px;
  margin: 0 0.1rem;
  box-shadow: #4177fe 0 0 0.05rem;
}
.hxsuccess p a:nth-child(2) {
  background: #4177fe
}
</style>
